<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="ekranbos" v-if="!Liste || !SeciliBina">Bina Seçiniz</div>
      <el-table
        v-if="Liste && SeciliBina"
        :data="Liste.filter(data => !search || data.AdSoyad.toLowerCase().includes(search.toLowerCase()) || data.kNo.toLowerCase().includes(search.toLowerCase()))"
        class="golgetable"
        :row-class-name="TableClass"
        width="100%"
        :height="Height"
        fixed
      >
        <el-table-column

          label="No"
          prop="kNo"
          width="50">
        </el-table-column>
        <el-table-column
          label="Kat"
          prop="Kat"
          width="50">
        </el-table-column>
        <el-table-column
          label="Ad Soyad"
          prop="AdSoyad">
        </el-table-column>
        <el-table-column
          label="Mülk"
          prop="SahipText"
          width="100">
        </el-table-column>
        <el-table-column
          label="Telefon"
          prop="Telefon"
          width="100">
        </el-table-column>
        <el-table-column
          label="Giriş Tarihi"
          prop="gTarihiText"
          width="120">
        </el-table-column>
        <el-table-column
          label="Çıkış Tarihi"
          prop="cTarihiText"
          width="120">
        </el-table-column>
        <el-table-column
          label="Borç"
          prop="Alacak"
          width="100"
          align="right">
        </el-table-column>
        <el-table-column
          label="Emanet"
          prop="Emanet"
          width="100"
          align="right">
        </el-table-column>

        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Sayfa.Arama"/>
          </template>
          <template slot-scope="scope">
            <el-button-group>
              <el-tooltip v-if="Yetki" class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <i
                  class="feather-edit-2  tableibtn text-primary"
                  @click="DuzenleBtn(scope.row)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Kişi Özet"
                          placement="top-start">
                <i
                  class="feather-airplay tableibtn text-success"
                  @click="$router.push('/yonetim/kisi/'+scope.row.Kisi_id)">
                </i>
              </el-tooltip>
              <el-tooltip v-if="scope.row.Silinebilir && Yetki" class="item" effect="dark"
                          :content="Sayfa.SilAdi"
                          placement="top-start">
                <i
                  class="feather-trash tableibtn text-danger"
                  @click="SilOnay(scope.row.Kisi_id)">
                </i>
              </el-tooltip>
            </el-button-group>

          </template>
        </el-table-column>
      </el-table>
      <FormModal v-if="Yetki" :data="FormData" :ModalOlayi="ModalOlayi" :Mesken="null"
                 @ModalOlayi="SayfaYukle"></FormModal>

    </div>
  </div>
</template>
<script>

import FormModal from "../../../components/Pack/Yonetim/kisi/FormModal";
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, FormModal},
  data() {
    return {
      Height: window.innerHeight - 150,
      Yetki: false,
      ModalOlayi: false,
      lo: false,
      Sayfa: {
        ButtonAdi: 'Yeni Kişi Ekle',
        DuzenleAdi: 'Düzenle',
        SilAdi: 'Sil',
        Button: null,
        Adi: 'Kişi Listesi',
        Menu: [],
        MenuDisplay: null
      },
      Liste: [],
      FormData: {},
      MeskenListe: {},
      search: '',
      SeciliBina: null

    }
  },
  methods: {
    TableClass({row}) {
      return row.Aktif
    },
    SayfaYukle() {
      this.lo = true;
      this.ModalOlayi = false;
      this.$store.dispatch("Get", {path: 'yonetim/kisi/liste/b/' + this.SeciliBina})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
    },
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/kisi/' + id})
        .then(response => {
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    YeniBtn() {
      this.ModalOlayi = true;
      this.this.FormData = {
        Baslik: 'Yeni Kişi Ekle',
        AdSoyad: null,
        Telefon: null,
        aKodu: "90",
        Mail: null,
        vDaire: null,
        vNo: null,
        dTarihi: null,
        Sahip: null,
        gTarihi: null,
        cTarihi: null,
        oOdeme: null,
        Mesken_id: null,
        Kisi_id: null,
        KB_id: null,
        Bilgi: {},
        IndirimListe: [],

      }
    },
    DuzenleBtn(Veri) {
      this.FormData = Veri;
      this.FormData.Baslik = Veri.AdSoyad + ' Düzenle';
      this.ModalOlayi = true;
    },
  },
  created() {
    if (this.$store.getters.BinaBilgi) {
      this.BinaBilgi = this.$store.getters.BinaBilgi;
      this.SeciliBina = this.BinaBilgi.id;
      this.SayfaYukle();

      this.$store.dispatch("Get", {path: 'yonetim/mesken/' + this.SeciliBina})
        .then(response => {
          if (response.Durum === 'OK') {
            this.MeskenListe = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })
    }


    this.$store.commit("SayfaBilgi", this.Sayfa);


  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Yonetim/kisi/Liste.vue